// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero_root__XMpth","title":"Hero_title__j6aGS","text":"Hero_text__3yZw5","link":"Hero_link__Keylv"};